import { iconStyle } from 'components/icons/_iconStyle'
import { cx } from 'linaria'

export const LinkedinMonoIcon = ({ className, ...rest }) => (
  <span className={cx(iconStyle, 'icon', className && className)} {...rest}>
    <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM8 19H5v-9h3v9ZM6.5 8.3c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8 1.8.8 1.8 1.8-.8 1.8-1.8 1.8ZM19 19h-3v-5.3c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V19h-3v-9h3v1.2c.5-.8 1.6-1.4 2.5-1.4 1.9 0 3.5 1.6 3.5 3.5V19Z"/></svg>
  </span>
)
  
